import { useMutation } from '@apollo/client'
import { SoftwareManagementDeleteSoftwareSetupDocument } from 'generated/resources/graphql'

export const useDeleteSoftwareSetup = () => {
  const [deleteSoftwareSetup, { loading }] = useMutation(
    SoftwareManagementDeleteSoftwareSetupDocument
  )

  return {
    delete(id: number) {
      return deleteSoftwareSetup({ variables: { id } })
    },
    loading,
  }
}
